import Header from '@components/common/Header/index';
import LeftNavigation from '@components/common/LeftNavigation/index';
import '../dashboard/dashboard.scss';
import { useLocation, useParams } from 'react-router-dom';

export default function DashboardLayout(props: any) {
	let { pathname } = useLocation();
	const routeWithFooterBackground = [
		// '/configuration/vendors/detail-info/map-to-locations/',
		'/configuration/vendors/detail-info/profile/',
		'/edit-user',
	];

	let isBackgroundVisible = false;
	routeWithFooterBackground.forEach((eachRoute) => {
		if (pathname.includes(eachRoute)) {
			isBackgroundVisible = pathname.includes(eachRoute);
			return;
		}
	});

	const styles = {} as Record<string, string>;
	if (isBackgroundVisible) {
		styles['backgroundImage'] = `url('/images/footer-image.svg')`;
	}

	return (
		<>
			<Header />
			<section className="main-wrapper main-wrapper--no-navigation-menu">
				<main
					className="main-wrapper__content w-100"
					style={styles}
					// style={{ backgroundImage: `url('/images/footer-image.svg')` }}
				>
					{props.children}
				</main>
			</section>
		</>
	);
}
